import { render, staticRenderFns } from "./AdditionalTable.vue?vue&type=template&id=36575b6b&scoped=true"
import script from "./AdditionalTable.vue?vue&type=script&lang=js"
export * from "./AdditionalTable.vue?vue&type=script&lang=js"
import style0 from "./AdditionalTable.vue?vue&type=style&index=0&id=36575b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36575b6b",
  null
  
)

export default component.exports